import CoreFullWidthImage from './CoreFullWidthImage';

export { type CoreFullWidthImageProps } from './CoreFullWidthImage';
export default CoreFullWidthImage;
